import {createDataStore} from './createDataStore';

// Caches /data/pytorchData.json for the PyTorch tutorial pages.
// See createDataStore for the fetch-once / persist-to-localStorage behaviour.
export const usePytorchDataStore = createDataStore(
    '/data/pytorchData.json',
    'pytorch-data-store',
    ['slugs', 'nextPage', 'relatedPages', 'suggestedCourses']
);
